
import { PageContentRow } from '../../components/PageContentRow/PageContentRow'
import { ProductDetailDisplay } from '../../components/ProductDetailDisplay/ProductDetailDisplay'
import { useContentContext } from '../../contexts/ContentContext'

import DynamicPage from '../DynamicPage/DynamicPage'

const Product = () => {
  const pageData = useContentContext()

  const { productDetail } = pageData.templateData || {};
  if(!productDetail) return <DynamicPage />

  return (
    <DynamicPage>
      {({ renderDynamicContent }) => (
        <>
          <PageContentRow>
            <ProductDetailDisplay {...productDetail} />
          </PageContentRow>
          {renderDynamicContent()}
        </>
      )}
    </DynamicPage>
  )
}

export default Product